var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCommentMonochrome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7415 9.50001C18.7449 10.8199 18.4434 12.1219 17.8617 13.3C17.172 14.7118 16.1117 15.8992 14.7996 16.7293C13.4874 17.5594 11.9753 17.9994 10.4325 18C9.1423 18.0035 7.86955 17.6951 6.7179 17.1L1.146 19L3.0033 13.3C2.4216 12.1219 2.12016 10.8199 2.12352 9.50001C2.12412 7.92177 2.55423 6.37486 3.36569 5.03256C4.17714 3.69026 5.33788 2.60558 6.7179 1.90001C7.86955 1.30494 9.1423 0.996572 10.4325 1.00001H10.9213C12.9588 1.115 14.8832 1.99477 16.3262 3.47087C17.7691 4.94697 18.6291 6.91567 18.7415 9.00001V9.50001Z",
    stroke: "#6A7889",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommentMonochrome);
export default __webpack_public_path__ + "static/media/icon-comment-monochrome.de65904a.svg";
export { ForwardRef as ReactComponent };